export default "__VITE_ASSET__C0cQGN5y__"